// src/types/AuthResponse.js
export class AuthResponse {
  constructor(data) {
    this.token = data.token;
    this.user = {
      id: data.user.id,
      first_name: data.user.first_name,
      last_name: data.user.last_name,
      email: data.user.email,
      role: data.user.role,
      tag_id: data.user.tag_id,
      tag: data.user.tag,
      gender: data.user.gender,
      birth_date: data.user.birth_date,
      fiscal_code: data.user.fiscal_code,
      address: data.user.address,
      phone: data.user.phone,
      therapist: data.user.therapist
    };
    this.role = data.role;
    this.has_survey = data.has_survey;
  }
}